import { Role } from "@api/graphql";

export const roleOptions = [
  {
    id: "role-report-royalties",
    label: "Report royalties",
    description: "I’m here to report the resale of artwork(s)",
    roleName: Role.RESALE_REPORTER,
  },
  {
    id: "role-collect-royalties",
    label: "Collect royalties",
    description: "I’m here to collect royalties on resales for artworks",
    roleName: Role.ROYALTY_RECIPIENT,
  },
];
